<script>
    import { afterUpdate } from 'svelte'

	export let notebook;
    export let entry;
    export let callback;

    let references = [];
    afterUpdate(() => {
        references =  notebook.find_references(entry)
    })
</script>

{#if references.length > 0}
<div id="references">
    <h2>Referenced By</h2>
    <ul>
    {#each references as ref}
        {#if ref.id != entry.id}
            <li on:click={() => callback(ref.id)}>{ref.name} ({ref.category})</li>
        {/if}
    {/each}
    </ul>
</div>
{/if}

<style>
ul {
    padding-left: 0px;
}
li {
    font-size: 18px;
    color: rgb(108, 189, 255);
    list-style-type: none;
}
li:hover {
    cursor: pointer;
}
</style>
